import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { BaseComponent } from './base/base.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FooterComponent } from './footer/footer.component';
import { NgbDropdownModule, NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { FeahterIconModule } from 'src/app/core-features/feather-icon/feather-icon.module';
import { ContentAnimateDirective } from 'src/app/core-features/content-animate/content-animate.directive';
import { LayoutService } from './services/layout.service';
import { AppHttpClient } from 'src/app/core-features/auth-guard/http-client.service';
import { WnDropdownComponent } from './wn-dropdown/wn-dropdown.component';
import { DropdownModule } from 'primeng/dropdown';
import { DataSharingService } from 'src/app/shared/services/data-sharing.service';
import { ProjectModule } from '../project/project.module';
// import { WnDropdownComponent } from './wn-dropdown/wn-dropdown.component';



const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};


@NgModule({
  declarations: [WnDropdownComponent, BaseComponent, NavbarComponent, SidebarComponent, FooterComponent, ContentAnimateDirective],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgbDropdownModule,
    NgbCollapseModule,
    PerfectScrollbarModule,
    FeahterIconModule,
    DropdownModule,
    ProjectModule
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    LayoutService,
    AppHttpClient,
    DataSharingService
  ]
})
export class LayoutModule { }
